module.exports = __webpack_public_path__ + "pc/img/swiper_02.1b131fa0.jpg";